import styled from 'styled-components';

/**
 * @author: Dumitrana Alinus <alin.designstudio@gmail.com>
 * @class: Content
 * @date:  18.03.2019
 * @time:  23:57
 * @scope:
 */
export const Content = styled.aside.attrs(() => ({ id: 'app__content' }))`
    & {
        max-width: 100%;
        background-color: #f5f5f5;
        flex: 1;
        position: relative;

        @media screen and (min-width: 768px) {
            display: inline-flex;
            flex: 1 1 auto;
            flex-direction: column;
            align-items: center;
            align-content: center;
            justify-content: flex-start;
            overflow: initial;
            z-index: 1;
            position: relative;

            .MuiDrawer-docked.active + & {
                max-width: calc(100% - 281px);
            }
        }
    }
`;
